@if (helpService.isOpen()) {
  <div class="help-overlay" (click)="helpService.close()"></div>
  <div class="help-panel">
    <div class="help-header">
      <div class="help-header-top">
        <div class="help-logo">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        </div>
        <span class="help-title">{{ content()?.pageTitle ?? 'Help Center' }}</span>
        <button class="help-close-btn" (click)="helpService.close()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <div class="help-search-wrap">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
        <input class="help-search" type="text" placeholder="Search help articles…"
          [value]="helpService.searchQuery()"
          (input)="helpService.searchQuery.set($any($event.target).value)">
      </div>
    </div>

    @if (content()) {
      <div class="help-body">
        <p class="help-summary">{{ content()!.summary }}</p>

        @if (content()!.quickTips.length && !helpService.searchQuery()) {
          <div class="help-section">
            <h4 class="help-section-title">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              Quick Tips
            </h4>
            <ul class="help-tips">
              @for (tip of content()!.quickTips; track tip) {
                <li class="help-tip">
                  <span class="tip-dot"></span>
                  {{ tip }}
                </li>
              }
            </ul>
          </div>
        }

        <div class="help-section">
          <h4 class="help-section-title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
            Articles
          </h4>
          @for (article of filteredArticles(); track article.title) {
            <details class="help-article">
              <summary class="help-article-title">{{ article.title }}</summary>
              <p class="help-article-body">{{ article.body }}</p>
            </details>
          }
          @if (filteredArticles().length === 0) {
            <p class="help-no-results">No articles match "{{ helpService.searchQuery() }}"</p>
          }
        </div>
      </div>
    }

    <div class="help-footer">
      <div class="help-contact">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        Need more help? <a href="#">Contact Support</a>
      </div>
    </div>
  </div>
}
